export default __webpack_public_path__ + "static/Martin_Wigchert_2-217207625c4e45dd85591083df98be6e.jpg";